"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsDateEnable = void 0;
var _utils = require("./utils");
var _react = require("react");
var useIsDateEnable = exports.useIsDateEnable = function useIsDateEnable(_ref) {
  var disableFuture = _ref.disableFuture,
    disablePast = _ref.disablePast,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate;
  return (0, _react.useCallback)(function (date) {
    var today = (0, _utils.getToday)();
    return Boolean(disableFuture && (0, _utils.isAfter)(date, today) || disablePast && (0, _utils.isBefore)(date, today) || minDate && (0, _utils.isBefore)(date, minDate) || maxDate && (0, _utils.isAfter)(date, maxDate));
  }, [disableFuture, disablePast, minDate, maxDate]);
};